import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import ChatRoom from "./pages/ChatRoom";
import AdminDashboard from "./pages/AdminDashboard";
import SplashScreen from "./components/SplashScreen";
import { Toaster } from "@/components/ui/sonner";
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(() => {
    return !sessionStorage.getItem('splashShown');
  });

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('chatAppToken');
    const storedUser = localStorage.getItem('chatAppUser');

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('chatAppToken');
        localStorage.removeItem('chatAppUser');
      }
    }
    setLoading(false);
  }, []);

  const handleAuth = (userData) => {
    setUser(userData);
  };

  const handleSignOut = () => {
    localStorage.removeItem('chatAppToken');
    localStorage.removeItem('chatAppUser');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#2e0510' }}>
        <div className="text-2xl font-bold" style={{ color: '#FFC857' }}>Loading...</div>
      </div>
    );
  }

  const handleSplashComplete = () => {
    sessionStorage.setItem('splashShown', 'true');
    setShowSplash(false);
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={user ? <Navigate to="/dashboard" /> : <Navigate to="/signin" />}
            />
            <Route
              path="/signin"
              element={user ? (user.role === 'super_admin' ? <Navigate to="/admin" /> : <Navigate to="/dashboard" />) : <SignIn onSignIn={handleAuth} />}
            />
            <Route
              path="/signup"
              element={user ? <Navigate to="/dashboard" /> : <SignUp onSignUp={handleAuth} />}
            />
            <Route
              path="/forgot-password"
              element={user ? <Navigate to="/dashboard" /> : <ForgotPassword />}
            />
            <Route
              path="/dashboard"
              element={user ? <Dashboard user={user} onSignOut={handleSignOut} /> : <Navigate to="/signin" />}
            />
            <Route
              path="/chat/:popupId"
              element={user ? <ChatRoom user={user} /> : <Navigate to="/signin" />}
            />
            <Route
              path="/admin"
              element={user && user.role === 'super_admin' ? <AdminDashboard user={user} onSignOut={handleSignOut} /> : <Navigate to="/signin" />}
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;